module.exports = __webpack_public_path__ + "img/content2.59b8fc2e.png";